export default "__VITE_ASSET__BYWUIAgX__"